<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <!-- 选择客户 -->
          <div class="tool">
            <h4>选择客户</h4>
            <div class="search">
              <el-select
                v-model="customerValue"
                placeholder="请选择客户"
                @change="customerChange"
                :loading="customerLoading"
                filterable>
                <el-option
                  v-for="item in customerData"
                  :key="item.client_id"
                  :label="item.number + ' ' + item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 提示词输入区 -->
          <div class="part">
            <div class="prompt_header">
              <h5>提示词</h5>
              <div class="prompt_actions">
                <el-button type="success" size="small" plain @click="handleAIEnhance" :disabled="!prompt || !prompt.trim()">
                  <i class="el-icon-magic-stick"></i> AI扩写润色
                </el-button>
                <el-button type="success" size="small" plain @click="handlePromptLibrary">
                  <i class="el-icon-reading"></i> 提示词库
                </el-button>
                <el-button type="success" size="small" plain @click="imageToPromptVisible = true">
                  <i class="el-icon-picture"></i> 图转提示词
                </el-button>
              </div>
            </div>
            <el-input
              type="textarea"
              :rows="6"
              placeholder="输入描述内容，例如：现代简约办公室，自然光，木地板，温暖的色调"
              v-model="prompt"
              maxlength="1000"
              show-word-limit>
            </el-input>
          </div>

          <!-- 选择模型 -->
          <div class="part">
            <h5>AI大模型（最多选择3个）</h5>
            <div class="">
              <el-checkbox-group v-model="aiSelected" :max="3">
                <div class="ai_box">
                  <el-checkbox v-for="(item,index) in aiModels" :key="'ai'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>

          <!-- 生成按钮 -->
          <div class="btn_save">
            <el-button
              type="success"
              :loading="isGenerating"
              @click="handleGenerate"
              :disabled="!prompt || !customerValue || aiSelected.length === 0"
              style="width:100%;">
              {{ isGenerating ? '生成中...' : '立即生成' + (aiSelected.length > 0 ? '（' + aiSelected.length + '个模型）' : '') }}
            </el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>

          <!-- 生成结果 -->
          <div class="part" v-if="generatedImages.length > 0">
            <h5>生成结果</h5>
            <div class="result_grid">
              <div
                v-for="(img, index) in generatedImages"
                :key="'result'+index"
                class="result_item">
                <img :src="img.file_url" alt="" class="result_image" @click="previewImage(img.file_url)">
                <div class="result_info">
                  <p class="result_model">{{ img.model_name }}</p>
                  <div class="result_actions">
                    <el-button size="mini" type="success" @click="toImageToVideo(img)">图生视频</el-button>
                    <el-button size="mini" type="success" plain @click="toAiEdit(img)">AI改图</el-button>
                    <el-button size="mini" type="success" plain @click="toFavorite(img, index)">
                      {{ img.is_favorited ? '取消收藏' : '收藏' }}
                    </el-button>
                    <el-button size="mini" type="success" plain @click="toDownload(img)">下载</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 优质示例展示 -->
          <div class="example_section" v-if="exampleList.length > 0">
            <div class="example_header">
              <h5>优质案例</h5>
            </div>
            <div class="example_grid">
              <div
                v-for="item in exampleList"
                :key="'example'+item.id"
                class="example_item"
                @click="previewExample(item)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
              </div>
            </div>
          </div>
        </div>

        <!-- 提示词库弹窗 -->
        <el-dialog
          title="提示词库"
          :visible.sync="libraryVisible"
          width="70%"
          :close-on-click-modal="false">
          <div class="library_description">选择预设的提示词来丰富你的描述</div>
          <div class="library_content">
            <el-tabs v-model="libraryTab" class="library_tabs">
              <el-tab-pane
                v-for="(category, index) in promptCategories"
                :key="'category'+index"
                :label="category.name"
                :name="String(index)">
                <div class="library_tags">
                  <el-button
                    v-for="(item, idx) in category.prompts"
                    :key="'prompt'+idx"
                    :type="selectedLibraryItems.includes(item) ? 'success' : 'default'"
                    :plain="!selectedLibraryItems.includes(item)"
                    size="small"
                    class="library_button"
                    @click="handleLibraryToggle(item)">
                    {{ item }}
                  </el-button>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="choose_list" v-if="selectedLibraryItems.length > 0">
            <div class="label">已选择：</div>
            <el-tag
              v-for="(item, index) in selectedLibraryItems"
              :key="'choose' + index"
              :closable="true"
              :disable-transitions="true"
              @close="handleLibraryItemClose(index)"
              type="success">
              {{item}}
            </el-tag>
          </div>
          <div slot="footer" class="dialog_footer">
            <el-button @click="libraryVisible = false">取消</el-button>
            <el-button type="success" @click="handleApplyLibrary" :disabled="selectedLibraryItems.length === 0">确定</el-button>
          </div>
        </el-dialog>

        <!-- 图转提示词弹窗 -->
        <el-dialog
          title="图转提示词"
          :visible.sync="imageToPromptVisible"
          width="600px"
          custom-class="image-to-prompt-dialog"
          :close-on-click-modal="false">
          <p class="hint_text">上传参考图或从素材库选择，AI 将自动生成详细的提示词描述</p>
          <div class="image_to_prompt_content">
            <!-- 选择方式按钮组 -->
            <div class="select_method_buttons">
              <el-upload
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleImageUpload"
                accept="image/*">
                <el-button type="success" plain style="width: 100%;">
                  <i class="el-icon-upload"></i> 上传图片
                </el-button>
              </el-upload>
              <el-button type="success" plain @click="openMaterialLibrary" style="width: 100%;">
                <i class="el-icon-picture-outline"></i> 从素材库选择
              </el-button>
            </div>

            <!-- 预览图片 -->
            <div v-if="uploadedImage" class="upload_preview_area">
              <div class="preview_label">预览图片</div>
              <div class="preview_image_wrapper">
                <img :src="uploadedImage" alt="预览图">
                <el-button size="mini" type="danger" class="clear_btn" @click="clearUploadedImage">
                  <i class="el-icon-delete"></i> 清除
                </el-button>
              </div>
            </div>

            <div v-if="generatedPromptText" class="generated_prompt_section">
              <h4>生成的提示词（可编辑）</h4>
              <el-input
                type="textarea"
                :rows="6"
                v-model="generatedPromptText"
                placeholder="AI 将自动生成提示词...">
              </el-input>
            </div>
          </div>
          <div slot="footer" class="dialog_footer">
            <el-button @click="imageToPromptVisible = false">取消</el-button>
            <el-button type="success" @click="handleApplyImagePrompt" :disabled="!generatedPromptText">应用到提示词</el-button>
          </div>
        </el-dialog>

        <!-- 素材库选择弹窗 -->
        <el-dialog
          title="选择素材"
          :visible.sync="materialLibraryVisible"
          width="80%"
          :close-on-click-modal="false">
          <div class="material_library_content">
            <!-- 分类筛选 -->
            <div class="material_filter">
              <el-radio-group v-model="materialType" @change="materialTypeChange">
                <el-radio-button label="风格"></el-radio-button>
                <el-radio-button label="空间类型"></el-radio-button>
                <el-radio-button label="公司案例"></el-radio-button>
                <el-radio-button label="项目案例"></el-radio-button>
              </el-radio-group>
            </div>

            <!-- 子分类标签 -->
            <div class="material_tags" v-if="materialType == '风格'">
              <el-tag :type="-1 == materialStyleCur ? 'success' : 'info'" @click="materialStyleClick(-1)" effect="light">全部</el-tag>
              <el-tag :type="index == materialStyleCur ? 'success' : 'info'" v-for="(item, index) in materialStyleData" :key="'mstyle'+index" effect="light" @click="materialStyleClick(index)">{{ item.style_type }}</el-tag>
            </div>
            <div class="material_tags" v-if="materialType == '空间类型'">
              <el-tag :type="-1 == materialSpaceCur ? 'success' : 'info'" @click="materialSpaceClick(-1)" effect="light">全部</el-tag>
              <el-tag :type="index == materialSpaceCur ? 'success' : 'info'" v-for="(item, index) in materialSpaceData" :key="'mspace'+index" effect="light" @click="materialSpaceClick(index)">{{ item.space_type }}</el-tag>
            </div>
            <div class="material_tags" v-if="materialType == '公司案例'">
              <el-tag :type="-1 == materialCompanyCur ? 'success' : 'info'" @click="materialCompanyClick(-1)" effect="light">全部</el-tag>
              <el-tag :type="index == materialCompanyCur ? 'success' : 'info'" v-for="(item, index) in materialCompanyData" :key="'mcompany'+index" effect="light" @click="materialCompanyClick(index)">{{ item.project_type }}</el-tag>
            </div>
            <div class="material_tags" v-if="materialType == '项目案例'">
              <el-tag :type="-1 == materialProjectCur ? 'success' : 'info'" @click="materialProjectClick(-1)" effect="light">全部</el-tag>
              <el-tag :type="index == materialProjectCur ? 'success' : 'info'" v-for="(item, index) in materialProjectData" :key="'mproject'+index" effect="light" @click="materialProjectClick(index)">{{ item.project_type }}</el-tag>
            </div>

            <!-- 素材列表 -->
            <div v-loading="materialLoading" class="material_grid">
              <div
                v-for="(item, index) in materialData"
                :key="'material'+index"
                :class="['material_item', { 'selected': isMaterialSelected(item) }]"
                @click="selectMaterial(item)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
                <div class="material_overlay" v-if="isMaterialSelected(item)">
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>

            <div v-if="materialData.length === 0 && !materialLoading" class="empty_state">
              <el-empty description="暂无素材"></el-empty>
            </div>
          </div>
          <div slot="footer" class="dialog_footer">
            <el-button @click="materialLibraryVisible = false">取消</el-button>
            <el-button type="success" @click="handleMaterialSelect" :disabled="!selectedMaterial">确定选择</el-button>
          </div>
        </el-dialog>

        <!-- 图片预览弹窗 -->
        <el-dialog
          :visible.sync="previewVisible"
          width="auto"
          :close-on-click-modal="true"
          custom-class="image-preview-dialog"
          :modal-append-to-body="true"
          :append-to-body="true">
          <img :src="previewImageUrl" class="preview-dialog-image">
        </el-dialog>

        <!-- 示例详情弹窗 -->
        <el-dialog
          title="示例详情"
          :visible.sync="exampleDetailVisible"
          width="80%"
          top="5vh"
          :close-on-click-modal="true"
          custom-class="example-detail-dialog">
          <div class="example_detail" v-if="currentExample">
            <div class="detail_left">
              <img :src="currentExample.photo_url" alt="">
            </div>
            <div class="detail_right">
              <div class="detail_item">
                <label>提示词/描述：</label>
                <p>{{ currentExample.description }}</p>
              </div>
              <div class="detail_item">
                <label>使用模型：</label>
                <p>{{ currentExample.model_name }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.style_type">
                <label>风格类型：</label>
                <p>{{ currentExample.style_type }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.space_type">
                <label>空间类型：</label>
                <p>{{ currentExample.space_type }}</p>
              </div>
              <div class="detail_actions">
                <el-button type="success" @click="useThisExample">使用此提示词</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SideBarComponent from '@/components/SideBarComponent'
import SubTitleComponent from '@/components/SubTitleComponent'
import { apiDownload } from '@/utils/download'

let _ajaxType = 0

export default {
  name: 'TextToImage',
  components: {
    HeaderComponent,
    SideBarComponent,
    SubTitleComponent
  },
  data() {
    return {
      title: '文生图',
      customerData: [],
      customerValue: '',
      customerLoading: false,
      prompt: '',
      quickPrompts: [],
      aiModels: [],
      aiSelected: [],
      isGenerating: false,
      generatedImages: [],
      pollTimer: null,
      libraryVisible: false,
      libraryTab: '0',
      selectedLibraryItems: [],
      imageToPromptVisible: false,
      uploadedImage: null,
      generatedPromptText: '',
      promptCategories: [],
      // 素材库相关
      materialLibraryVisible: false,
      materialType: '风格',
      materialStyleData: [],
      materialSpaceData: [],
      materialCompanyData: [],
      materialProjectData: [],
      materialStyleCur: -1,
      materialSpaceCur: -1,
      materialCompanyCur: -1,
      materialProjectCur: -1,
      materialData: [],
      materialLoading: false,
      selectedMaterial: null,
      // 图片预览相关
      previewVisible: false,
      previewImageUrl: '',
      // 示例展示相关
      exampleList: [],
      exampleDetailVisible: false,
      currentExample: null
    }
  },
  created() {
    this.getCustomerList()
    this.getAIModelList()
    this.getPromptLibrary()
    this.getQuickPrompts()
    this.getExampleList()
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.customerLoading = true
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        console.log('客户列表响应:', json.data)
        let _data = json.data.data
        if (json.data.errcode === 0) {
          this.customerData = _data.result
          console.log('客户数据:', this.customerData)

          // 如果是客户端，自动选中当前客户
          if (this.global.type === 'client' && this.global.clientId) {
            this.customerValue = parseInt(this.global.clientId)
          }
          // 如果是管理端且只有一个客户，自动选中
          else if (this.customerData.length === 1) {
            this.customerValue = this.customerData[0].client_id
          }
          // 如果管理端有记忆的客户名称，自动选中
          else if (this.global.type === 'manage' && this.global.clientName) {
            const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
            if (rememberedClient) {
              this.customerValue = rememberedClient.client_id
            }
          }
          // 默认选择第一个客户
          else if (this.customerData.length > 0 && !this.customerValue) {
            this.customerValue = this.customerData[0].client_id
            console.log('默认选中第一个客户:', this.customerData[0].client_name)
          }
        } else {
          this.$message.error(json.data.error || '获取客户列表失败')
        }
      }).catch(err => {
        console.error('获取客户列表错误:', err)
        this.$message.error('网络错误，无法获取客户列表')
      }).finally(() => {
        this.customerLoading = false
      })
    },
    // 客户选择变化
    customerChange(val) {
      console.log('选择客户 ID:', val)
      const selectedCustomer = this.customerData.find(c => c.client_id === val)
      if (selectedCustomer) {
        console.log('选择的客户:', selectedCustomer.client_name)
        // 记住选中的客户（用于下次自动选中）
        this.global.clientId = selectedCustomer.client_id
        this.global.clientName = selectedCustomer.client_name
      }
    },
    // 快速提示词点击
    handleQuickPrompt(item) {
      this.prompt = item
    },
    // 打开提示词库
    handlePromptLibrary() {
      this.libraryVisible = true
      this.selectedLibraryItems = []
    },
    // 提示词库项选择切换
    handleLibraryToggle(item) {
      const index = this.selectedLibraryItems.indexOf(item)
      if (index > -1) {
        this.selectedLibraryItems.splice(index, 1)
      } else {
        this.selectedLibraryItems.push(item)
      }
    },
    // 移除已选择的提示词
    handleLibraryItemClose(index) {
      this.selectedLibraryItems.splice(index, 1)
    },
    // 应用提示词库
    handleApplyLibrary() {
      if (this.selectedLibraryItems.length > 0) {
        this.prompt = this.selectedLibraryItems.join('，')
      }
      this.libraryVisible = false
      this.selectedLibraryItems = []
    },
    // 获取AI模型列表
    getAIModelList() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 4  // 4=文生图模型
      }
      this.axios.post(_url, _aiData).then(json => {
        if (json.data.errcode === 0) {
          this.aiModels = json.data.data.result
        }
      }).catch(() => {
        // 暂时使用模拟数据
        this.aiModels = [
          { model_id: 'stability-sd', model_name: 'Stability SD', price: '约1元/张' },
          { model_id: 'nano-banana', model_name: 'Nano banana pro', price: '约1.2元/张' },
          { model_id: 'modelslab', model_name: 'Modelslab', price: '约0.5元/张' }
        ]
      })
    },
    // 获取提示词库
    getPromptLibrary() {
      let _url = "/api/?mod=lexicon"
      console.log('正在获取提示词库...', _url)
      this.axios.post(_url).then(json => {
        console.log('提示词库API响应:', json.data)
        if (json.data.errcode === 0) {
          // 转换数据格式：result -> categories
          const result = json.data.data.result || []
          this.promptCategories = result.map(item => {
            return {
              name: item.label,
              prompts: item.lexicon.map(lex => lex.word)
            }
          })
          console.log('提示词库数据已加载:', this.promptCategories)
          // 默认选中第一个分类
          if (this.promptCategories.length > 0) {
            this.libraryTab = '0'
          }
        } else {
          console.error('提示词库API返回错误:', json.data.error)
        }
      }).catch(err => {
        console.error('获取提示词库失败:', err)
      })
    },
    // 获取快速提示词
    getQuickPrompts() {
      let _url = "/api/?mod=prompt_library&action=quick"
      console.log('正在获取快速提示词...', _url)
      this.axios.post(_url).then(json => {
        console.log('快速提示词API响应:', json.data)
        if (json.data.errcode === 0) {
          this.quickPrompts = json.data.data.result
          console.log('快速提示词数据已加载:', this.quickPrompts)
        } else {
          console.error('快速提示词API返回错误:', json.data.error)
        }
      }).catch(err => {
        console.error('获取快速提示词失败:', err)
      })
    },
    // 立即生成
    handleGenerate() {
      if (!this.customerValue) {
        this.$message.warning('请选择客户')
        return
      }
      if (!this.prompt) {
        this.$message.warning('请输入提示词')
        return
      }
      if (this.aiSelected.length === 0) {
        this.$message.warning('请选择模型')
        return
      }

      console.log('开始生成图片，选择的模型:', this.aiSelected)

      this.isGenerating = true
      this.generatedImages = [] // 清空之前的结果

      // 为每个选中的模型发送请求
      const generatePromises = this.aiSelected.map(modelId => {
        let _data = {
          client_id: this.customerValue,
          description: this.prompt,
          model_id: modelId,
          photo_url: '',  // 文生图不需要底图
          style_photo_url: '',  // 可选的风格参考图
          space_type: '',  // 可选的空间类型
          style_type: ''  // 可选的风格类型
        }

        // 检查模型是否需要英文翻译
        let nowAi = this.aiModels.find(c => c.model_id === modelId)
        if (nowAi && nowAi.language === 'en') {
          // 需要翻译，先调用翻译API
          return this.translateAndGenerateAsync(_data)
        } else {
          // 不需要翻译，直接生成
          return this.submitGenerateAsync(_data)
        }
      })

      // 等待所有请求完成
      Promise.all(generatePromises).then(results => {
        console.log('所有生成任务已提交:', results)
      }).catch(error => {
        console.error('生成任务提交失败:', error)
        this.isGenerating = false
        this.$message.error('生成任务提交失败')
      })
    },
    // 翻译并生成（异步版本）
    translateAndGenerateAsync(data) {
      return new Promise((resolve, reject) => {
        let _url = "/api/?mod=translate"
        let _translateData = {
          description: data.description
        }

        this.axios.post(_url, _translateData).then(json => {
          console.log('翻译响应:', json.data)
          if (json.data.errcode === 0) {
            // 使用翻译后的英文描述
            data.description = json.data.data.description_en
            this.submitGenerateAsync(data).then(resolve).catch(reject)
          } else {
            this.$message.error(json.data.error || '翻译失败')
            reject(new Error(json.data.error || '翻译失败'))
          }
        }).catch(error => {
          console.error('翻译失败:', error)
          this.$message.error('翻译网络错误')
          reject(error)
        })
      })
    },
    // 提交生成任务（异步版本）
    submitGenerateAsync(data) {
      return new Promise((resolve, reject) => {
        let _url = "/api/?mod=effect&action=save-text"

        this.axios.post(_url, data).then(json => {
          console.log('生成任务提交响应:', json.data)
          if (json.data.errcode === 0) {
            // 开始轮询结果
            this.startPollingAsync(json.data.data.effect_id, data.model_id)
            resolve(json.data.data.effect_id)
          } else {
            this.$message.error(json.data.error || '生成失败')
            reject(new Error(json.data.error || '生成失败'))
          }
        }).catch(error => {
          console.error('生成任务提交失败:', error)
          this.$message.error('网络错误')
          reject(error)
        })
      })
    },
    // 开始轮询结果（支持多任务）
    startPollingAsync(effectId, modelId) {
      console.log('开始轮询任务结果，effect_id:', effectId, 'model_id:', modelId)

      // 增加待处理任务计数
      if (!this.pendingTasks) {
        this.pendingTasks = 0
      }
      this.pendingTasks++

      let pollCount = 0
      const maxPolls = 60 // 最多轮询60次（2分钟）

      const poll = () => {
        pollCount++
        console.log(`轮询第 ${pollCount} 次，effect_id: ${effectId}`)

        if (pollCount > maxPolls) {
          this.pendingTasks--
          if (this.pendingTasks <= 0) {
            this.isGenerating = false
            this.pendingTasks = 0
          }
          this.$message.error(`模型 ${modelId} 生成超时`)
          return
        }

        let _url = "/api/?mod=effect&action=result"
        let _data = {
          effect_id: effectId
        }

        this.axios.post(_url, _data).then(json => {
          console.log('轮询响应:', json.data)

          if (json.data.errcode === 0) {
            let result = json.data.data
            let resultsLength = result.result ? result.result.length : 0
            console.log('任务状态:', result.status, '结果数量:', resultsLength)

            if (result.status === 1) {
              // 生成成功，将结果追加到数组
              const newImages = result.result || []
              this.generatedImages = [...this.generatedImages, ...newImages]

              this.pendingTasks--
              console.log(`模型 ${modelId} 生成完成，剩余任务: ${this.pendingTasks}`)

              if (this.pendingTasks <= 0) {
                this.isGenerating = false
                this.pendingTasks = 0
                this.$message.success(`生成完成！共生成 ${this.generatedImages.length} 张图片`)
              }
            } else if (result.status === 2) {
              // 生成失败
              this.pendingTasks--
              this.$message.error(`模型 ${modelId} 生成失败`)

              if (this.pendingTasks <= 0) {
                this.isGenerating = false
                this.pendingTasks = 0
              }
            } else {
              // status === 0，继续轮询
              setTimeout(poll, 2000)
            }
          } else {
            this.pendingTasks--
            if (this.pendingTasks <= 0) {
              this.isGenerating = false
              this.pendingTasks = 0
            }
            this.$message.error(json.data.error || '查询失败')
          }
        }).catch(error => {
          console.error('轮询请求失败:', error)
          this.pendingTasks--
          if (this.pendingTasks <= 0) {
            this.isGenerating = false
            this.pendingTasks = 0
          }
          this.$message.error('网络错误')
        })
      }

      // 立即执行第一次轮询
      poll()
    },
    // AI扩写润色
    handleAIEnhance() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      const loading = this.$loading({
        lock: true,
        text: 'AI正在优化提示词...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _url = "/api/?mod=translate&action=refine"
      let _content = this.prompt
      let _uploadData = {
        description: _content,
        language: 'cn'
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data)
        if (json.data.errcode === 0) {
          this.prompt = _data.description.replace('\n\n', '')
          this.$message.success('提示词已优化')
        } else {
          this.$message.error(json.data.error || 'AI优化失败')
        }
      }).catch(() => {
        _ajaxType = 0
        this.$message.error('网络错误')
      }).finally(() => {
        loading.close()
      })
    },
    // 处理图片上传
    handleImageUpload(file) {
      // 验证文件类型
      const isImage = file.raw.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      // 验证文件大小（不超过10MB）
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }

      // 读取文件并显示预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedImage = e.target.result
        // 调用OSS直传
        this.uploadToOSS(file.raw)
      }
      reader.readAsDataURL(file.raw)
    },
    // OSS直传
    uploadToOSS(file) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传图片...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 1. 获取OSS签名
      let _url = "/api/?mod=oss&action=signature"
      this.axios.post(_url).then(json => {
        if (json.data.errcode !== 0) {
          this.$message.error(json.data.error || '获取签名失败')
          loading.close()
          return
        }

        const ossData = json.data.data
        const timestamp = Date.now()
        const random = Math.floor(Math.random() * 10000)
        const fileExt = file.name.split('.').pop()
        const fileName = `${timestamp}${random}.${fileExt}`
        const key = ossData.dir + fileName

        // 2. 构造FormData上传到OSS
        const formData = new FormData()
        formData.append('key', key)
        formData.append('policy', ossData.policy)
        formData.append('OSSAccessKeyId', ossData.accessid)
        formData.append('signature', ossData.signature)
        formData.append('success_action_status', '200')
        formData.append('file', file)

        // 3. 直接上传到OSS
        loading.text = 'AI正在分析图片...'
        this.axios.post(ossData.host, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          // 不使用Authorization header
          transformRequest: [(data, headers) => {
            delete headers.Authorization
            return data
          }]
        }).then(() => {
          // 上传成功，构造完整URL
          const photoUrl = ossData.host + '/' + key

          // 4. 调用图转提示词API
          this.generatePromptFromOSSImage(photoUrl, loading)
        }).catch(() => {
          this.$message.error('图片上传失败')
          loading.close()
        })
      }).catch(() => {
        this.$message.error('网络错误')
        loading.close()
      })
    },
    // 使用OSS图片URL生成提示词
    generatePromptFromOSSImage(photoUrl, loading) {
      console.log('调用图转提示词API，图片URL:', photoUrl)

      let _url = "/api/?mod=translate&action=image"
      let _data = {
        photo_url: photoUrl
      }

      this.axios.post(_url, _data).then(json => {
        console.log('图转提示词API响应:', json.data)

        if (json.data.errcode === 0) {
          // 获取content并去除HTML标签
          const htmlContent = json.data.data.content || ''
          this.generatedPromptText = this.stripHtmlTags(htmlContent)
          this.$message.success('提示词生成成功')
        } else {
          console.error('图转提示词失败:', json.data)
          this.$message.error(json.data.error || '图片分析失败')
        }
      }).catch(error => {
        console.error('图转提示词网络错误:', error)
        this.$message.error('网络错误')
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    // 清除上传的图片
    clearUploadedImage() {
      this.uploadedImage = null
      this.generatedPromptText = ''
    },
    // 去除HTML标签
    stripHtmlTags(html) {
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },
    // 应用图转提示词
    handleApplyImagePrompt() {
      if (this.generatedPromptText) {
        this.prompt = this.generatedPromptText
        this.imageToPromptVisible = false
        this.$message.success('提示词已应用')
      }
    },
    // 打开素材库
    openMaterialLibrary() {
      this.materialLibraryVisible = true
      this.selectedMaterial = null
      // 初始化素材库数据
      this.getMaterialCategories()
      this.getMaterialList()
    },
    // 获取素材分类
    getMaterialCategories() {
      // 使用 deploy 接口获取所有分类数据
      let deployUrl = "/api/?mod=deploy"
      this.axios.post(deployUrl).then(json => {
        if (json.data.errcode === 0) {
          const data = json.data.data
          this.materialStyleData = data.style || []
          this.materialSpaceData = data.space || []
          this.materialCompanyData = data.case_project_type1 || []
          this.materialProjectData = data.case_project_type2 || []
          console.log('素材分类数据:', data)
        }
      }).catch(error => {
        console.error('获取素材分类失败:', error)
      })
    },
    // 获取素材列表
    getMaterialList() {
      this.materialLoading = true
      let _url = "/api/?mod=material"
      let params = {
        page: 1,
        pagesize: 50,
        type: 0  // 0=素材库，1=个人素材库
      }

      // 根据当前选择的类型和分类添加筛选参数
      if (this.materialType === '风格') {
        if (this.materialStyleCur >= 0) {
          params.style_type = this.materialStyleData[this.materialStyleCur].style_type
        }
      } else if (this.materialType === '空间类型') {
        if (this.materialSpaceCur >= 0) {
          params.space_type = this.materialSpaceData[this.materialSpaceCur].space_type
        }
      } else if (this.materialType === '公司案例') {
        _url = '/api/?mod=case'
        params.case_type = 1
        if (this.materialCompanyCur >= 0) {
          params.project_type = this.materialCompanyData[this.materialCompanyCur].project_type
        }
      } else if (this.materialType === '项目案例') {
        _url = '/api/?mod=case'
        params.case_type = 2
        if (this.materialProjectCur >= 0) {
          params.project_type = this.materialProjectData[this.materialProjectCur].project_type
        }
      }

      console.log('获取素材列表，参数:', params)

      this.axios.post(_url, params).then(json => {
        console.log('素材列表响应:', json.data)
        if (json.data.errcode === 0) {
          this.materialData = json.data.data.result || []
        } else {
          this.$message.error(json.data.error || '获取素材失败')
        }
      }).catch(error => {
        console.error('获取素材列表失败:', error)
        this.$message.error('网络错误')
      }).finally(() => {
        this.materialLoading = false
      })
    },
    // 素材类型切换
    materialTypeChange() {
      // 重置当前选择的分类
      this.materialStyleCur = -1
      this.materialSpaceCur = -1
      this.materialCompanyCur = -1
      this.materialProjectCur = -1
      this.selectedMaterial = null
      this.getMaterialList()
    },
    // 风格分类点击
    materialStyleClick(index) {
      this.materialStyleCur = index
      this.selectedMaterial = null
      this.getMaterialList()
    },
    // 空间类型点击
    materialSpaceClick(index) {
      this.materialSpaceCur = index
      this.selectedMaterial = null
      this.getMaterialList()
    },
    // 公司案例点击
    materialCompanyClick(index) {
      this.materialCompanyCur = index
      this.selectedMaterial = null
      this.getMaterialList()
    },
    // 项目案例点击
    materialProjectClick(index) {
      this.materialProjectCur = index
      this.selectedMaterial = null
      this.getMaterialList()
    },
    // 选择素材
    selectMaterial(item) {
      console.log('选择素材:', item)
      console.log('当前选中:', this.selectedMaterial)
      this.selectedMaterial = item
      console.log('更新后选中:', this.selectedMaterial)
    },
    // 判断素材是否被选中
    isMaterialSelected(item) {
      if (!this.selectedMaterial) {
        return false
      }
      // 素材库数据有 material_id
      if (item.material_id && this.selectedMaterial.material_id) {
        return this.selectedMaterial.material_id === item.material_id
      }
      // 案例数据有 case_id
      if (item.case_id && this.selectedMaterial.case_id) {
        return this.selectedMaterial.case_id === item.case_id
      }
      // 兜底：比较 photo_url
      return this.selectedMaterial.photo_url === item.photo_url
    },
    // 确认选择素材
    handleMaterialSelect() {
      if (!this.selectedMaterial) {
        return
      }

      console.log('选中的素材:', this.selectedMaterial)

      // 关闭素材库弹窗
      this.materialLibraryVisible = false

      // 清理图片URL，移除OSS处理参数
      let cleanPhotoUrl = this.selectedMaterial.photo_url
      if (cleanPhotoUrl.includes('?')) {
        cleanPhotoUrl = cleanPhotoUrl.split('?')[0]
      }

      console.log('原始URL:', this.selectedMaterial.photo_url)
      console.log('清理后URL:', cleanPhotoUrl)

      // 设置预览图（保留原始URL用于显示）
      this.uploadedImage = this.selectedMaterial.photo_url

      // 调用图转提示词API（使用清理后的URL）
      const loading = this.$loading({
        lock: true,
        text: 'AI正在分析图片...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      this.generatePromptFromOSSImage(cleanPhotoUrl, loading)
    },
    // 图生视频
    toImageToVideo(img) {
      console.log('跳转到图生视频，图片:', img)
      // 将图片URL存储到localStorage，供图生视频页面使用
      localStorage.setItem('effect_url', img.file_url)
      localStorage.setItem('effect_space', img.space_type || '效果图')
      // 跳转到图生视频页面
      this.$router.push({ path: '/effectvideo' })
    },
    // AI改图
    toAiEdit(img) {
      console.log('跳转到AI改图，图片:', img)
      // 将图片URL存储到localStorage，供AI改图页面使用
      localStorage.setItem('effect_url', img.file_url)
      localStorage.setItem('effect_space', img.space_type || '效果图')
      // 跳转到AI改图页面
      this.$router.push({ path: '/effectaiedit' })
    },
    // 收藏/取消收藏
    toFavorite(img, index) {
      console.log('收藏操作，图片:', img)

      let _url = "/api/?mod=effect_favorite&action=add"
      let _data = {
        effect_result_id: img.effect_result_id
      }

      // 如果已经收藏，则取消收藏
      if (img.is_favorited) {
        _url = "/api/?mod=effect_favorite&action=cancel"
        _data = {
          effect_favorite_id: img.effect_favorite_id
        }
      }

      this.axios.post(_url, _data).then(json => {
        console.log('收藏响应:', json.data)
        if (json.data.errcode === 0) {
          // 更新收藏状态
          this.$set(this.generatedImages[index], 'is_favorited', !img.is_favorited)

          // 如果是添加收藏，保存favorite_id
          if (!img.is_favorited) {
            this.$set(this.generatedImages[index], 'effect_favorite_id', json.data.data.effect_favorite_id)
          }

          this.$message.success(img.is_favorited ? '取消收藏成功' : '收藏成功')
        } else {
          this.$message.error(json.data.error || '操作失败')
        }
      }).catch(error => {
        console.error('收藏操作失败:', error)
        this.$message.error('网络错误')
      })
    },
    // 下载图片
    toDownload(img) {
      console.log('下载图片:', img)

      let _href = ''
      let _imgUrl = img.file_url

      // 处理OSS URL，转换为代理路径
      if (_imgUrl.startsWith('https://oss.ylw.s136.ailo.vip')) {
        _href = _imgUrl.replace('https://oss.ylw.s136.ailo.vip', '/ai_images')
      } else if (_imgUrl.startsWith('https://aigc.oss.ylwai.cn')) {
        _href = _imgUrl.replace('https://aigc.oss.ylwai.cn', '/ai2_images')
      } else {
        // 如果不是OSS URL，直接使用原URL
        _href = _imgUrl
      }

      console.log('下载路径:', _href)

      // 调用下载函数
      apiDownload(_href)
    },
    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl
      this.previewVisible = true
    },
    // 获取示例列表
    getExampleList() {
      let _url = "/api/?mod=example&action=list"
      let _data = {
        type: 3,  // 3=文生图
        pagesize: 10
      }
      this.axios.post(_url, _data).then(json => {
        if (json.data.errcode === 0) {
          this.exampleList = json.data.data.result || []
        }
      }).catch(error => {
        console.error('获取示例列表失败:', error)
      })
    },
    // 预览示例详情
    previewExample(item) {
      this.currentExample = item
      this.exampleDetailVisible = true
    },
    // 使用此提示词
    useThisExample() {
      if (this.currentExample) {
        // 填充提示词
        this.prompt = this.currentExample.description || ''
        this.exampleDetailVisible = false
        this.$message.success('已应用示例配置')
      }
    }
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  background: #f5f5f5;
  padding: 10px;
  .box {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    .tool {
      margin-bottom: 20px;
      h4 {
        margin-bottom: 10px;
        font-size: 16px;
        color: #333;
      }
      .search {
        /deep/ .el-select {
          width: 300px;
        }
      }
    }
    .part {
      margin-bottom: 20px;
      h5 {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
      }
      .prompt_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .prompt_actions {
          display: flex;
          gap: 10px;
        }
      }
      .quick_prompts {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        .quick_tag {
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .ai_box {
        font-size: 0;
        .el-radio {
          margin: 0 30px 20px 0;
        }
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .result_grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      .result_item {
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        overflow: hidden;
        .result_image {
          width: 100%;
          height: 250px;
          object-fit: cover;
        }
        .result_info {
          padding: 15px;
          .result_model {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 10px;
            text-align: center;
          }
          .result_actions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
        }
      }
    }
  }
  .library_description {
    margin-bottom: 0;
    padding: 15px 20px;
    background-color: #f0f9ff;
    color: #666;
    font-size: 14px;
    line-height: 1.6;
  }
  .library_content {
    background: #fff;
    min-height: 300px;
    .library_tabs {
      /deep/ .el-tabs__header {
        margin: 0;
        background: #f5f7fa;
      }
      /deep/ .el-tabs__nav-scroll {
        padding: 0 20px;
      }
      /deep/ .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
      }
    }
    .library_tags {
      min-height: 200px;
      padding: 20px;
      font-size: 0;
      .library_button {
        margin: 0 10px 10px 0;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(80, 184, 92, 0.3);
        }
      }
    }
  }
  .choose_list {
    margin-top: 0;
    padding: 15px 20px;
    background: #f9fafb;
    border-top: 1px solid #e4e7ed;
    font-size: 0;
    .label {
      display: inline-block;
      margin-right: 10px;
      font-size: 14px;
      line-height: 32px;
      color: #606266;
      font-weight: 500;
    }
    .el-tag {
      margin: 0 10px 10px 0;
      font-size: 14px;
    }
  }
  .dialog_footer {
    text-align: right;
    background: #fff;
    padding: 15px 20px;
    margin: 0;
    border-top: 1px solid #e4e7ed;
    .el-button {
      min-width: 80px;
    }
  }
  .hint_text {
    margin: 0;
    padding: 15px 20px;
    background-color: #f0f9ff;
    color: #666;
    font-size: 14px;
    line-height: 1.6;
  }
  .image_to_prompt_content {
    background: #fff;
    padding: 0;
    // 选择方式按钮组
    .select_method_buttons {
      padding: 15px 20px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      /deep/ .el-upload {
        width: 100%;
      }
      .el-button {
        height: 36px;
        font-size: 13px;
        padding: 8px 15px;
      }
    }
    // 预览图片区域
    .upload_preview_area {
      padding: 0 20px 20px 20px;
      .preview_label {
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
        font-weight: 500;
      }
      .preview_image_wrapper {
        position: relative;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 10px;
        background: #fafafa;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 200px;
          object-fit: contain;
          border-radius: 4px;
          display: block;
          margin: 0 auto;
        }
        .clear_btn {
          margin-top: 10px;
        }
      }
    }
    .generated_prompt_section {
      padding: 0 20px 20px 20px;
      border-top: 1px solid #e4e7ed;
      padding-top: 20px;
      h4 {
        margin-bottom: 10px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
      /deep/ .el-textarea__inner {
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }
  // 素材库弹窗样式
  .material_library_content {
    background: #fff;
    min-height: 400px;
    .material_filter {
      padding: 20px;
      background: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
    }
    .material_tags {
      padding: 15px 20px;
      background: #fafafa;
      border-bottom: 1px solid #e4e7ed;
      .el-tag {
        margin: 0 10px 10px 0;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          transform: translateY(-2px);
        }
      }
    }
    .material_grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 15px;
      padding: 20px;
      max-height: 500px;
      overflow-y: auto;
      .material_item {
        position: relative;
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 8px;
        overflow: hidden;
        transition: all 0.3s;
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        &.selected {
          border-color: #50b85c;
          box-shadow: 0 0 0 2px rgba(80, 184, 92, 0.2);
        }
        img {
          width: 100%;
          height: 150px;
          object-fit: cover;
          display: block;
        }
        .material_overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(80, 184, 92, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 48px;
            color: #fff;
          }
        }
      }
    }
    .empty_state {
      padding: 60px 20px;
      text-align: center;
    }
  }
}
// 弹窗整体样式优化
/deep/ .el-dialog {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
/deep/ .el-dialog__header {
  background: linear-gradient(135deg, #f0f9ff 0%, #e8f5e9 100%);
  padding: 24px 24px 20px !important;
  border-bottom: 2px solid #50b85c;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    padding-left: 8px;
    letter-spacing: 0.5px;
  }
}
/deep/ .el-dialog__body {
  background: #fff;
  padding: 0;
}
/deep/ .el-dialog__footer {
  background: #fff;
  padding: 0;
}
/deep/ .el-dialog__close {
  color: #909399;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s;
  &:hover {
    color: #50b85c;
    transform: rotate(90deg);
  }
}
// 图转提示词弹窗 - 标题加大
/deep/ .image-to-prompt-dialog {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
    }
  }
}
// 图片预览弹窗样式
/deep/ .image-preview-dialog {
  background: transparent;
  box-shadow: none;
  margin: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .preview-dialog-image {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    display: block;
    border-radius: 8px;
  }
}
// 示例展示样式
.example_section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  .example_header {
    margin-bottom: 15px;
    h5 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
  }
  .example_grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    .example_item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }
      .example_info {
        padding: 10px;
        .example_title {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .example_desc {
          font-size: 12px;
          color: #666;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.4;
          height: 33.6px;
        }
        .example_model {
          font-size: 12px;
          color: #50b85c;
          margin-bottom: 8px;
        }
        .example_tags {
          .el-tag {
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
// 示例详情弹窗样式 - 使用深度选择器
::v-deep .example-detail-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff !important;

  .el-dialog__header {
    background: linear-gradient(135deg, #f0f9ff 0%, #e8f5e9 100%);
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;

    .el-dialog__title {
      color: #fff !important;
      font-size: 18px !important;
      font-weight: 600 !important;
    }

    .el-dialog__headerbtn {
      top: 20px !important;
      right: 20px !important;

      .el-dialog__close {
        color: #fff !important;
        font-size: 20px !important;

        &:hover {
          color: rgba(255, 255, 255, 0.8) !important;
        }
      }
    }
  }

  .el-dialog__body {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
    background: #fff !important;
    padding: 0 !important;
  }
}
.example_detail {
  display: flex;
  gap: 30px;
  padding: 20px;
  background: #fff;
  .detail_left {
    flex: 1;
    img {
      width: 100%;
      max-height: 60vh;
      object-fit: contain;
      border-radius: 8px;
    }
  }
  .detail_right {
    flex: 1;
    .detail_item {
      margin-bottom: 15px;
      label {
        display: block;
        font-size: 14px;
        color: #999;
        margin-bottom: 5px;
      }
      p {
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }
    .detail_actions {
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TextToImage/Index.vue